import { lazy } from 'react';
import { RouteObject } from 'react-router';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';
import PublicGuard from 'utils/route-guard/PublicGuard';

const AuthLogin = Loadable(lazy(() => import('pages/auth/login')));
const AuthRegister = Loadable(lazy(() => import('pages/auth/register')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/auth/forgot-password')));
const AuthCheckMail = Loadable(lazy(() => import('pages/auth/check-mail')));
const AuthResetPassword = Loadable(lazy(() => import('pages/auth/reset-password')));
const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));

const AuthRoutes: RouteObject = {
  path: '/organization/:organizationId',
  element: (
    <PublicGuard>
      <CommonLayout layout={'blank'} />
    </PublicGuard>
  ),
  errorElement: <MaintenanceError />,
  children: [
    {
      path: 'login',
      element: <AuthLogin />
    },
    {
      path: 'register',
      element: <AuthRegister />
    },
    {
      path: 'forgot-password',
      element: <AuthForgotPassword />
    },
    {
      path: 'check-mail',
      element: <AuthCheckMail />
    },
    {
      path: 'reset-password',
      element: <AuthResetPassword />
    }
  ]
};

export { AuthRoutes };
